const replacementRegexMap = {
  numeric: /[^0-9]+/gu,
  alphanumeric: /[^\dA-Za-z]+/gu,
};

type ReplacementType = keyof typeof replacementRegexMap;

export function stripNonMatching(value: string, type: ReplacementType): string {
  return value.replace(replacementRegexMap[type], '');
}
